import styled, { css } from 'styled-components';

export const StepContainer = styled.div<{
  isActive: boolean;
  isDone: boolean;
}>`
  display: flex;
  align-items: center;
  border-radius: 25px;
  padding: 8px 12px;

  ${({ isActive, isDone, theme }) =>
    isActive && isDone
      ? css`
          background-color: ${theme.positiveColor}40;
        `
      : isActive &&
        css`
          background-color: rgba(22, 32, 86, 0.1);
        `}
`;

export const StepCircle = styled.div<{ isActive: boolean }>`
  width: 32px;
  height: 32px;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: ${({ theme }) => theme.fontSemiBold};
  font-size: ${({ theme }) => theme.sizeMedium};

  ${({ isActive, theme }) =>
    isActive
      ? css`
          background-color: ${theme.primaryFrontColor};
          color: ${theme.primaryBackgroundColor};
        `
      : css`
          background-color: ${theme.gray25};
          color: ${theme.primaryBackgroundColor};
        `}
`;
